import withAemIntegration from "../../../../withAemIntegration";
import loadable from "../../../../utils/loadable";

const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/DriversOwnersManualForm")
);

const ComponentEditConfig = {
  emptyLabel: "Order Owner's Manual",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props) => {

  return {
    campaignCode: props?.campaignCode || "LWLX05060000",
    headline: props?.heading,
    privacyRightsHeading: props?.privacyHeading,
    privacyRightsText: props?.privacyText,
    formLabels: {
      firstName: props?.firstName,
      lastName: props?.lastName,
      address1: props?.addressOne,
      address2: props?.addressTwo,
      address2Optional: "OPTIONAL",
      city: props?.city,
      state: props?.state,
      zipCode: props?.zipCode,
    },
    confirmationHeadline: "THANK YOU",
    confirmationSubline:
      "We have received your submission and you will hear from us shortly.",
    backToBrowseCta: {
      text: "CLOSE",
      theme: "SecondaryBlack",
      type: "button",
      breakpoints: [],
    },
    ...props,
  };
};

const OrderManual = (props) => {
  const data = transformData(props);
  return <Component {...data} />;
};

export default withAemIntegration(
  "lexus/components/drivers/forms/order-manual"
)(OrderManual, ComponentEditConfig);
